module.exports = __webpack_public_path__ + "static/media/weapon_augment.c7fa53b2.png";